module.exports = __webpack_public_path__ + "img/medicalInsuranceLevel.ec302833.svg";